import React from 'react';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://musique-prete.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Obtenir le pack Musique Prête™',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-primary px-7 py-[18px] text-center text-[15px] font-bold uppercase leading-tight tracking-[0.04em] text-primary-foreground shadow-cta transition-[transform,background-color] duration-150 ease-out-strong hover:-translate-y-0.5 hover:bg-primary-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/40 active:translate-y-0 sm:gap-3 sm:px-10 sm:py-5 sm:text-base sm:tracking-[0.05em] ${className}`} data-id="element-51" data-mp="qjsadgf0l989">
      <DownloadIcon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-52" data-mp="35yz6t45gzsf8" />
      <span data-id="element-53" data-mp="39z9jt0rojj3l">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out-strong group-hover:translate-x-1" aria-hidden="true" data-id="element-54" data-mp="3a0kp550rwywt" />
    </a>;
}